const options = {
	apiUrl: "https://groff.dscvit.com/api/",
	wssUrl: "https://groff.dscvit.com",
};

export default options;
